module.exports = __webpack_public_path__ + "e4985ff6d1836de0b61ba3f260adff32-nei_page_hero_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/header/assets/nei_page_hero_2x.jpg
// module id = 570
// module chunks = 0